export default __webpack_public_path__ + "static/media/auditHover.7cb2dcbb.svg";